import React from 'react';

import GridContainer from './GridContainer';
import GridMetadata from './GridMetadata';

export default function GridMetadataTab({gridId}: {gridId: string}): JSX.Element {
  return <GridContainer gridId={gridId}>{(childProps) => <GridMetadata {...childProps} />}</GridContainer>;
}
